import {
  IDatabaseTimeTrackerItemResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabaseTimeTrackerItemResponseInstance'
import {i18n} from '@toolify/client/src/setup/i18n'

export function getTimeTrackerItemName(
  databaseTimeTrackerItem: IDatabaseTimeTrackerItemResponseInstance,
  fallbackDatabaseItemName?: string,
): string {
  if(!databaseTimeTrackerItem) {
    return i18n.global.t('general.workingOnSomething')
  }
  if(!databaseTimeTrackerItem.databaseItemId) {
    return i18n.global.t('datePicker.noRecordAssigned')
  }
  const databaseItemName = databaseTimeTrackerItem.databaseItemName !== undefined
    ? databaseTimeTrackerItem.databaseItemName
    : fallbackDatabaseItemName
  if(databaseItemName === undefined) {
    return i18n.global.t('general.workingOnSomething')
  }
  return (databaseItemName ?? '').trim() || i18n.global.t('general.noName')
}
